'use strict';

module.exports = [require('./derivative'), // simplify
require('./simplify'), // polynomial
require('./rationalize'), // decomposition
require('./decomposition/qr'), require('./decomposition/lup'), require('./decomposition/slu'), // solver
require('./solver/lsolve'), require('./solver/lusolve'), require('./solver/usolve')];


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/function/algebra/index.js
// module id = 4BFd
// module chunks = 3